import { useMemo } from 'react';
import guideHtml from '@/content/help/guide.html?raw';

// Screenshots are bundled with the app (not served from public/), so the guide is reachable only through
// this signed-in page. Vite resolves each to its hashed asset URL.
const SHOTS = import.meta.glob('@/content/help/*.jpg', { eager: true, query: '?url', import: 'default' });
const shotUrl = Object.fromEntries(Object.entries(SHOTS).map(([path, url]) => [path.split('/').pop(), url]));

// In-page links (#market, #faq …) scroll inside the frame instead of navigating it.
const ANCHOR_SCRIPT = `<script>
document.addEventListener('click', function (e) {
  var a = e.target.closest('a[href^="#"]');
  if (!a) return;
  var el = document.getElementById(a.getAttribute('href').slice(1));
  if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
});
</script>`;

/**
 * Help: the "Getting started with NEO" guide (screenshots use sample names), shown inside the app layout
 * so the top nav stays as it is. Signed-out visitors get the login page, like every non-public route.
 */
export default function Help() {
  const srcDoc = useMemo(
    () => guideHtml
      .replace(/src="([\w.-]+\.jpg)"/g, (m, file) => (shotUrl[file] ? `src="${shotUrl[file]}"` : m))
      .replace('</body>', `${ANCHOR_SCRIPT}</body>`),
    []
  );
  return (
    <iframe
      srcDoc={srcDoc}
      title="Getting started with NEO"
      className="w-full border-0 bg-transparent"
      style={{ height: 'calc(100vh - 64px - 4rem)' }}
    />
  );
}
